import { getAccessToken as getProviderAccessToken } from "@cw-elements/auth-provider";

const getLegacyAccessToken = (): string => {
  const storedTokens =
    localStorage.getItem("tokens") ?? sessionStorage.getItem("tokens") ?? "";

  try {
    return String(JSON.parse(storedTokens)?.access_token ?? "");
  } catch {
    return "";
  }
};

export const getAccessToken = (): string => {
  try {
    const providerToken = getProviderAccessToken();
    if (typeof providerToken === "string" && providerToken.length > 0) {
      return providerToken;
    }
  } catch {
    // Keep requests safe when provider storage is absent or invalid.
  }

  return getLegacyAccessToken();
};
